import { useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import MenuIcon from '@mui/icons-material/Menu';
import { Button } from "@mui/material";
import { useShallow } from 'zustand/react/shallow';

import { ROUTES } from '~/const';
import { trans, setLang, getLink } from "~/providers/lang";
import { myUseState } from "~/hooks/myUseState";
import { getClassName } from "~/utils/utils";
import { mainStore } from "~/stores/main";
import { useMediaResponsive } from "~/hooks/useMediaResponsive";

import "./style.less";

interface IState {
	hamburgerVisible: boolean;
	menuVisible: boolean;
	pathname: string;
}

const SET_LANG = {
	cs: "Nastavit češtinu",
	sk: "Nastaviť slovenštinu",
	en: "Set english",
};

export default function Menu() {
	useMediaResponsive();

	const { lang, isSmallDevice } = mainStore(useShallow(state => ({
		lang: state.data.lang,
		isSmallDevice: state.data.isSmallDevice,
	})));
	const { pathname } = useLocation();
	const { state, updateState, toggleState } = myUseState<IState>({
		hamburgerVisible: isSmallDevice,
		menuVisible: !isSmallDevice,
		pathname,
	});

	function getClassNameActive(menuLang: string) {
		return [menuLang, ...menuLang === lang ? ["active"] : []].join(" ");
	}

	function getLinkClassName({ isActive }, isHome?: boolean): string {
		const homeTest = isHome && location.pathname === "/";

		return isActive || homeTest ? "active" : "";
	}

	function onMenuClick() {
		isSmallDevice && updateState({
			menuVisible: false,
		});
	}

	const fbLangs = <div className="fb-langs">
		<span className="sites">
			<a href="https://www.facebook.com/pages/Svatebn%C3%AD-agentura-IVANA/430024587111636" className="facebook" title="Facebook" target="_blank" rel="noreferrer">
				<FacebookIcon sx={{ fill: "var(--color-title)" }} />
			</a>
			<a href="https://instagram.com/ivana_bridal_salon" className="facebook" title="Instagram" target="_blank" rel="noreferrer">
				<InstagramIcon sx={{ fill: "var(--color-title)" }} />
			</a>
		</span>
		<span className="langs">
			<a href="#" className={getClassNameActive("cs")} onClick={() => setLang('cs')} title={SET_LANG.cs}>
				<img src="/img/flags/cs.png?v2" alt="" />
				{ lang === "cs" && <img className="active-icon" src="/img/flags/active.svg" alt="" /> }
			</a>
			<a href="#" className={getClassNameActive("sk")} onClick={() => setLang('sk')} title={SET_LANG.sk}>
				<img src="/img/flags/sk.png?v2" alt="" />
				{ lang === "sk" && <img className="active-icon" src="/img/flags/active.svg" alt="" /> }
			</a>
			<a href="#" className={getClassNameActive('en')} onClick={() => setLang('en')} title={SET_LANG.en}>
				<img src="/img/flags/en.png?v2" alt="" />
				{ lang === "en" && <img className="active-icon" src="/img/flags/active.svg" alt="" /> }
			</a>
		</span>
	</div>;

	useEffect(() => {
		if (pathname !== state.pathname && state.hamburgerVisible && state.menuVisible) {
			updateState({
				menuVisible: false,
			});
		}

		updateState({
			pathname,
		});
	}, [pathname, state.pathname, state.hamburgerVisible, state.menuVisible]);

	useEffect(() => {
		updateState({
			hamburgerVisible: isSmallDevice,
			menuVisible: !isSmallDevice,
		});
	}, [isSmallDevice]);

	return <div className="menu">
		{ state.hamburgerVisible && <div className="responsive">
			<span className="hamburger">
				<Button className="hamburgerBtn" onClick={() => toggleState("menuVisible")}>
					<MenuIcon sx={{ fill: "var(--color-title)" }} />
				</Button>
			</span>
			<span className="responsive__title">{ trans("menu.logo") }</span>
			<span className="responsive__last">
				<img src="/img/main-logo-new.png?1" alt="" />
			</span>
		</div> }
		{ !state.hamburgerVisible && fbLangs }
		<h1 className="logo-image">
			<span className="main-title">{trans('home.title')}</span>
			<Link to={getLink(ROUTES.home)}>
				<img src="/img/main-logo-new.png?1" alt={trans('menu.logo')} />
			</Link>
		</h1>
		{ state.menuVisible && <div className={getClassName(["main-menu", state.hamburgerVisible ? "is-responsive" : ""])}>
			<ul>
				<li>
					<NavLink to={getLink(ROUTES.home)} className={data => getLinkClassName(data, true)} onClick={onMenuClick}>
						{trans('menu.home')}
					</NavLink>
				</li>
				<li>
					<NavLink to={getLink(ROUTES.wedding)} className={data => getLinkClassName(data)} onClick={onMenuClick}>
						{trans('menu.wedding')}
					</NavLink>
				</li>
				<li>
					<NavLink to={getLink(ROUTES.formal)} className={data => getLinkClassName(data)} onClick={onMenuClick}>
						{trans('menu.formal')}
					</NavLink>
				</li>
				<li>
					<NavLink to={getLink(ROUTES.schoolWedding)} className={data => getLinkClassName(data)} onClick={onMenuClick}>
						{trans('menu.schoolWedding')}
					</NavLink>
				</li>
				<li>
					<NavLink to={getLink(ROUTES.action)} className={data => getLinkClassName(data)} onClick={onMenuClick}>
						{trans('menu.action')}
					</NavLink>
				</li>
				<li>
					<NavLink to={getLink(ROUTES.galeries)} className={data => getLinkClassName(data)} onClick={onMenuClick}>
						{trans('menu.gallery')}
					</NavLink>
				</li>
				<li>
					<NavLink to={getLink(ROUTES.contacts)} className={data => getLinkClassName(data)} onClick={onMenuClick}>
						{trans('menu.contacts')}
					</NavLink>
				</li>
				<li>
					<NavLink to={getLink(ROUTES.gdpr)} className={data => getLinkClassName(data)} onClick={onMenuClick}>
						{trans('menu.gdpr')}
					</NavLink>
				</li>
			</ul>
			{ state.hamburgerVisible && fbLangs }
		</div> }
	</div>;
}
